import { GeoAreaRoute } from '@/features/geo-area/navigation/geoAreaRoute';
import { OrganizationProfileScreen } from '@/features/geo-area/screens/OrganizationProfileScreen';
import { OrganizationWebviewScreen } from '@/features/geo-area/screens/OrganizationWebviewScreen';
import { AppStack } from '@/navigation/stacks/appStack';

/**
 * Todo: currently there are some issues with using form sheets as presentation for the screens
 * - On Android: form sheet can be closed with swipe down
 * - On iOS: the save area of the view is causing huge spacing on the top
 * - On both: Alerts are being displayed behind form sheet (so far only containedModal works fine)
 * Todo: check in future if the issues are easy fixable and use form sheet with the passed configuration
 */
export const useGeoAreaRouting = () => ({
  geoAreaScreens: [
    <AppStack.Screen
      key={GeoAreaRoute.OrganizationProfile}
      name={GeoAreaRoute.OrganizationProfile}
      component={OrganizationProfileScreen}
    />,
    <AppStack.Screen
      key={GeoAreaRoute.OrganizationWebview}
      name={GeoAreaRoute.OrganizationWebview}
      component={OrganizationWebviewScreen}
      options={() => ({
        title: undefined,
        headerShown: false
      })}
    />
  ]
});
